import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, Platform } from 'ionic-angular';
import { ErrorsComponent } from '../errors/errors.component';

@IonicPage()
@Component({
  selector: 'errors-page',
  templateUrl: 'errors-page.html',
})
export class ErrorsPage {
  isWeb: boolean;
  showActionButtons: boolean;

  @ViewChild('errors') errors: ErrorsComponent;

  constructor(
    public navParams: NavParams,
    public platform: Platform,
    public navCtrl: NavController
  ) {
    this.showActionButtons = navParams.get('showActionButtons');
  }

  async ionViewDidEnter() {
    await this.errors.refreshErrors();
  }
}



// WEBPACK FOOTER //
// ./src/pages/shared/components/errors-page/errors-page.ts